import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import propTypes from 'prop-types';

const HeroFormatter = styled.div`
  display: flex;
  align-items: unset;
  justify-content: center;
  font-size: 3.2rem;
  p {
    font-size: 1.8rem;
    padding: 3px 3px 0px 3px;
    font-weight: bold;
  }
`

const TBHeroCurrency = ({ stat }) => {
  const [heroText, setText] = useState({symbol: '', decimal: '', whole: ''})

  useEffect(() => {
    let symbol = ''
    let decimal;
    let whole = '';
    for (let i = 0; i < stat.length; i++) {
      let char = stat[i];
      if (char === '-' || char === '$') {
        symbol = symbol = symbol + char
      }
      else if (char !== '.') {
        whole = whole + char
      } else {
        decimal = stat.slice(i + 1)
        break;
      }
    }
    setText({decimal: decimal, whole: whole, symbol: symbol})
  }, [stat])

  return (
    <HeroFormatter>
      <p>{heroText.symbol}</p>
      {heroText.whole}
      <p>{heroText.decimal}</p>
    </HeroFormatter>
  )
}

TBHeroCurrency.propTypes = {
  stat: propTypes.string,
}

export default TBHeroCurrency;